import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/{${apiConstants.code}}/home/:code?`,
        name: `${apiConstants.code}.home`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "mb-home" */ './views/home.vue'),
        meta: {
            auth: undefined,
            title: 'home.title',
        }
    },
];

export default routes;